import React from 'react';
import { formatPhoneNumber } from './code';

//------------------------------------------------------ TypeScript interfaces ------------------------------------------------------
interface TelProps {
    className?: string;
    style?: React.CSSProperties | null;
    children?: string;
    value?: string;
    link?: boolean;
    [key: string]: any;
}
//------------------------------------------------------ TypeScript interfaces ------------------------------------------------------

export const Tel: React.FC<TelProps> = ({
    className = '',
    style = null,
    children,
    value = '',
    link = false,
    seperateCarrier = false,
    ...props
}) => {
    // Clean phone number (remove spaces, dashes, parentheses, plus sign)
    const cleanPhoneNumber = (phone: string): string => {
        return phone.replace(/[\s\-\(\)\+]/g, '');
    };

    // Format phone number for display with hyphens instead of spaces

    const displayValue = children || value;

    const formattedDisplay = seperateCarrier
        ? formatPhoneNumber(
              displayValue,
              'text-danger text-decoration-underline',
              'text-muted',
              'text-muted'
          )
        : formatPhoneNumber(displayValue);
    const cleanValue = cleanPhoneNumber(displayValue);

    // Default LTR styles
    const ltrStyle = { direction: 'ltr', display: 'inline-block', ...(style || {}) };

    // Determine element type based on link prop
    const elementType = link ? 'a' : 'span';

    // If link=true, render as anchor with href
    if (link) {
        return React.createElement(
            elementType,
            {
                ...props,
                href: `tel:${cleanValue}`,
                className,
                style: ltrStyle,
                dir: 'ltr',
            },
            formattedDisplay
        );
    }

    // Otherwise render as span without href
    return React.createElement(
        elementType,
        { ...props, className, style: ltrStyle, dir: 'ltr' },
        formattedDisplay
    );
};
